import * as React from 'react';

import { List } from '@nelnet/unifi-components-react';

import NavDrawerItem from './NavDrawerItem';
import usePageData, { sortChildren } from '../../../hooks/usePageData';
import useNavPrimary from '../../../hooks/useNavPrimary';
import { INavPrimaryItems } from '../../../utils/declarations';

interface IRenderNavItems {
  activePage: string;
  activePath?: string;
}

const themeOrder = ['demo', 'unifi', 'task'];

const filterNavChildren = (
  activePage: string, // title
  currPath: string, // slug
  parent: string, // depth0 slug
  sortOrder: [],
) => {
  let tree = usePageData({ type: 'tree', slug: `/${parent}/`, returnChildren: true });

  if (sortOrder.length) {
    tree = sortChildren(sortOrder, tree);
  }

  // Return child NavDrawerItem
  return (
    tree.length &&
    tree.map((item) => {
      const title = item.title || '';
      const slug = item.slug;
      const active = title === activePage || currPath.includes(slug);
      const hasChildren = item.children;

      const showChildren = title === activePage || slug === currPath || currPath.includes(slug);

      // Process children if is sub category parent
      if (hasChildren) {
        let nestedChildren = hasChildren;
        if (slug === '/theming/') {
          nestedChildren = sortChildren(themeOrder, nestedChildren);
        } else if (sortOrder.length) {
          nestedChildren = sortChildren(sortOrder, nestedChildren);
        }
        return (
          <NavDrawerItem
            depth={1}
            key={slug}
            item={slug}
            showChildren={showChildren}
            title={title}
            active={active}
          >
            {nestedChildren.map((childItem) => {
              if (childItem.title) {
                const childActive = childItem.title === activePage;
                return (
                  <NavDrawerItem
                    depth={2}
                    key={childItem.slug}
                    title={childItem.title}
                    href={childItem.slug}
                    active={childActive}
                  />
                );
              }
              return;
            })}
          </NavDrawerItem>
        );
      }

      // Output single item only if direct child
      return <NavDrawerItem depth={1} key={title} title={title} href={slug} active={active} />;
    })
  );
};

const renderNavItems = ({ activePage, activePath }: IRenderNavItems) => {
  const currPath = activePath !== undefined ? activePath : '/';
  const navPrimary: INavPrimaryItems[] = useNavPrimary();

  return (
    <nav>
      <List>
        {navPrimary.map(({ title, slug, children, childSortOrder }) => {
          const active = title === activePage || currPath.includes(`/${slug}/`);

          if (active && children) {
            return (
              <NavDrawerItem
                depth={0}
                key={slug}
                item={slug}
                showChildren={true}
                title={title}
                active={active}
              >
                {filterNavChildren(activePage, currPath, slug, childSortOrder)}
              </NavDrawerItem>
            );
          }

          return <NavDrawerItem depth={0} key={slug} item={slug} title={title} active={active} />;
        })}
      </List>
    </nav>
  );
};

export default renderNavItems;
